module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.15a3107f.png";